import { render } from "./InputLabel.vue?vue&type=template&id=fda64dec&scoped=true"
import script from "./InputLabel.vue?vue&type=script&lang=js"
export * from "./InputLabel.vue?vue&type=script&lang=js"

import "./InputLabel.vue?vue&type=style&index=0&id=fda64dec&scoped=true&lang=css"

import exportComponent from "/home/sites/fcs_dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fda64dec"],['__file',"resources/js/common/components/atoms/InputLabel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fda64dec"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fda64dec', __exports__)) {
    console.log('reload')
    api.reload('fda64dec', __exports__)
  }
  
  module.hot.accept("./InputLabel.vue?vue&type=template&id=fda64dec&scoped=true", () => {
    console.log('re-render')
    api.rerender('fda64dec', render)
  })

}


export default __exports__